import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface ModuleInfoProps {
  icon?: React.ComponentProps<typeof Icon.Large>['icon']
  name?: string
  description?: string
  iconBackground: string
}

const ModuleInfo = ({ icon, name, description, iconBackground }: ModuleInfoProps) => {
  return (
    <Box gap="s12">
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Box
          padding="s4"
          borderRadius={{ all: 'abs016' }}
          style={{
            backgroundColor: iconBackground,
          }}
        >
          <Icon.Large icon={icon ?? 'rocket'} color="grey000White" />
        </Box>
        <Text.Header1 weight="bold">{name}</Text.Header1>
      </Box>
      <Box paddingRight="s16">
        <Text.Normal color="grey700">{description}</Text.Normal>
      </Box>
    </Box>
  )
}

export default ModuleInfo
